import axios from 'axios';

/**
 * Cliente HTTP das telas públicas (agendamento, pedido, página /p/{slug}, contratação).
 *
 * Fica separado do AxiosInstance de propósito: aquele anexa o JWT e trata expiração de
 * sessão, o que não faz sentido para visitante sem login e ainda poderia deslogar alguém
 * que abriu uma tela pública na mesma aba.
 */
export const API_URL = process.env.REACT_APP_API_URL;

const publicAxios = axios.create({
    baseURL: API_URL,
});

export default publicAxios;
